module.exports = __webpack_public_path__ + "img/air@2x.caa10fd1.png";